import React from 'react'
import BuyerFields from './Role/BuyerFields'
import SellerFields from './Role/SellerFields'

const UserFieldsView = (props) => {
    return props.seller ? (
        <SellerFields
            data={props.data}
            populateValidation={props.populateValidation}
            fieldValue={props.fieldValue}
            function={props.function}
            customInitial={props.customInitial}
            customValidation={props.customValidation}
            additionalFormikUpdate={props.additionalFormikUpdate}
            changePassword={props.changePassword}
            formatPhone={props.formatPhone}
            phoneField={props.phoneField}
            standalone={props.standalone}
            loadOff={props.loadOff}
            empPassword={props.empPassword}
        />
    ) : (
        <BuyerFields
            data={props.data}
            populateValidation={props.populateValidation}
            fieldValue={props.fieldValue}
            function={props.function}
            customInitial={props.customInitial}
            customValidation={props.customValidation}
            additionalFormikUpdate={props.additionalFormikUpdate}
            invoiceTab={props.invoiceTab}
            changePassword={props.changePassword}
            noCredits={props.noCredits}
            creditLabel={props.creditLabel}
            formatPhone={props.formatPhone}
            phoneField={props.phoneField}
            creditTextChange={props.creditTextChange}
            standalone={props.standalone}
            loadOff={props.loadOff}
        />
    )
}

export default UserFieldsView
